<template>
    <div class="container mt-3">
        <div class="new-create">
            <div class="row">
                <div class="col-md-12 new-background mb-5">

                    <h1 class="mb-4 mt-4 new-heading" v-if="!department">Update Department</h1>
                    <h1 class="mb-4 mt-4 new-heading" v-if="department">Add Department</h1>

                    <form>
                        <div class="form-group mb-3">
                            <label><b>Department Title</b></label>
                            <input type="text" class="form-control"
                                   placeholder="Enter Title"
                                   v-model="departmentAdd.department"
                                   required name="department"
                                   v-validate="'required|max:255'">
                            <small v-if="errors.has('department')" class="text-danger">
                                {{ errors.first('department') }}
                            </small>
                        </div>

                        <div class="mb-5 mt-3">
                            <button type="button"
                                    class="btn btn-primary"
                                    v-if="!department"
                                    @click="update_department()">UPDATE
                            </button>
                            <button type="button" class="btn btn-primary" v-if="department" @click="add_department()">ADD
                            </button>
                            <router-link :to="{name: 'website-departments'}" class="btn my-4 btn-secondary">
                                Back
                            </router-link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";

export default {
  name: "CreateDepartments",
  components: { Editor },
  data() {
    return {
      departmentAdd: {},
      department: true
    };
  },
  methods: {
    add_department: function() {
      this.departmentAdd.access_token = localStorage.getItem("access_token");
      this.departmentAdd.admin_id = localStorage.getItem("admin_id");
      axios({
        method: "POST",
        url: "admin/sus-team/department/add",
        data: this.departmentAdd,
        headers: {
          "content-type": "application/json"
        }
      }).then(
        result => {
          if (result.data.status === true) {
            this.$swal("Department Added Successfully", "", "success");
          }
        },
        error => {
          this.$swal("Error", "There was an error. Please try again", "error");
          error;
        }
      );
    },
    getsingleDepartment() {
      axios({
        url:
          "/admin/sus-team/department/" +
          this.$route.params.department_id +
          "?access_token=" +
          localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.departmentAdd = result.data.department;
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    update_department: function() {
      this.departmentAdd.access_token = localStorage.getItem("access_token");
      axios({
        method: "PUT",
        url:
          "/admin/sus-team/department/update/" +
          this.$route.params.department_id,
        data: this.departmentAdd,
        headers: {
          "content-type": "application/json"
        }
      }).then(
        result => {
          if (result.data.status === true) {
            this.$swal("Department Updated Successfully", "", "success");
          }
        },
        error => {
          this.$swal("Error", "There was an error. Please try again", "error");
          error;
        }
      );
    }
  },
  mounted: function() {
    if (this.$route.params.department_id > 0) {
      this.department = false;
      this.getsingleDepartment();
    } else {
      this.departmentAdd = {};
      this.department = true;
    }
  }
};
</script>

<style lang="scss">
.new-create {
  padding-right: 20px;
  padding-left: 20px;
  .new-heading {
    font-size: 35px;
  }
  .form-control:focus {
    box-shadow: 0 0 0 0.2rem rgb(255, 255, 255);
  }
  .new-background {
    border-radius: 4px;
    box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.08);
    border: solid 0.5px #e8ebf2;
    background-color: #ffffff;
  }
}
</style>
